/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type of activity event
 * @export
 */
export const ActivityEventType = {
    ClaimCreated: 'claim_created',
    AppraisalRequested: 'appraisal_requested',
    AppraisalResponded: 'appraisal_responded',
    ClaimUpdated: 'claim_updated',
    StatusChanged: 'status_changed',
    DocumentUploaded: 'document_uploaded',
    FileUploaded: 'file_uploaded',
    ComparisonRun: 'comparison_run',
    ComparisonCompleted: 'comparison_completed',
    ComparisonFailed: 'comparison_failed',
    CommentAdded: 'comment_added',
    NoteCreated: 'note_created',
    TaskCreated: 'task_created',
    TaskCompleted: 'task_completed',
    TaskAssigned: 'task_assigned',
    ClaimAssigned: 'claim_assigned',
    SupplementCreated: 'supplement_created',
    SupplementCompleted: 'supplement_completed',
    SupplementFailed: 'supplement_failed',
    SupplementJustificationUpdated: 'supplement_justification_updated',
    EmailSent: 'email_sent',
    EmailReceived: 'email_received',
    UserInvited: 'user_invited',
    SystemEvent: 'system_event'
} as const;
export type ActivityEventType = typeof ActivityEventType[keyof typeof ActivityEventType];


export function instanceOfActivityEventType(value: any): boolean {
    for (const key in ActivityEventType) {
        if (Object.prototype.hasOwnProperty.call(ActivityEventType, key)) {
            if (ActivityEventType[key as keyof typeof ActivityEventType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ActivityEventTypeFromJSON(json: any): ActivityEventType {
    return ActivityEventTypeFromJSONTyped(json, false);
}

export function ActivityEventTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivityEventType {
    return json as ActivityEventType;
}

export function ActivityEventTypeToJSON(value?: ActivityEventType | null): any {
    return value as any;
}

export function ActivityEventTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ActivityEventType {
    return value as ActivityEventType;
}

